import { ThemeColors } from '@/src/context/ThemeContext';
import React from 'react';

export interface BlogPost {
  slug: string;
  title: string;
  titleEs: string;
  date: string; // ISO 8601 e.g. "2026-03-05"
  summary: string;
  summaryEs: string;
  tags: string[];
  Content: React.FC<{ colors: ThemeColors }>;
  ContentEs?: React.FC<{ colors: ThemeColors }>;
}
